export default __webpack_public_path__ + "static/media/tweet.d4871b0a.jpg";